import {KEY_POINT_TOKENS} from "../constants/tokens";

export const BASIC_COINS_INCOME = 2;

export const KEY_POINT_INCOME = {
  [KEY_POINT_TOKENS.MINE]: 1,
  [KEY_POINT_TOKENS.SUPER_MINE]: 2,
  [KEY_POINT_TOKENS.RUINS]: 2,
  [KEY_POINT_TOKENS.SUPER_RUINS]: 4,
}
export const RUINS_INCREASED_INCOME = {
  [KEY_POINT_TOKENS.RUINS]: 4,
  [KEY_POINT_TOKENS.SUPER_RUINS]: 8,
}
export const GUILD_BASIC_INCOME = 1;
export const TEMPLE_BASIC_INCOME = 1;
export const INCOME_INFLUENCE_PATH_LENGTH = 5;